import ListingPage from '../../components/ListingPage';
import SegmentsCards from '../../components/Segments/segmentsCards';

const SegmentsPage = () => {
  return (
    <ListingPage
      entityType="segment"
      useStats={true}
      filterBy="name"
      Cards={SegmentsCards}
      createRestrictionKey="segmentsCreate"
    />
  );
};

export default SegmentsPage;
